import React from 'react';
import { Text, ScrollView, View, StyleSheet, TouchableOpacity, Linking } from 'react-native';
import Clipboard from '@react-native-clipboard/clipboard';
import Toast from 'react-native-toast-message';
import Colors from '../../assets/Colors';
import { MdEmail, MdPhone, MdLocationPin, MdCalendarMonth } from 'react-icons/md';
import { FaExternalLinkAlt, FaWhatsapp, FaInstagram } from 'react-icons/fa';


function Mercato({ mercato, index }) {

  const viewLocandina = () => {
    Linking.openURL(mercato.url);
  };

  return (
    <View>
      {index !== 0 && <View style={{ paddingTop: 17 }} />}
      {mercato.name &&
        <View style={styles.sectionText}>
          <View style={{ flex: 1, paddingRight: 7 }}>
            <Text style={{ paddingLeft: 15, fontWeight: 'bold', flexShrink: 1 }}>
              {mercato.name}
            </Text>
          </View>
          {mercato.url &&
            <TouchableOpacity onPress={viewLocandina}>
              <Text style={styles.urlText}>locandina</Text>
            </TouchableOpacity>
          }
        </View>
      }
      {mercato.where &&
        <View style={styles.sectionText}>
          <MdLocationPin size={15} color={Colors.black} />
          <Text style={styles.itemText}>
            {mercato.where}
          </Text>
        </View>
      }
      {mercato.when &&
        <View style={styles.sectionText}>
          <MdCalendarMonth size={15} color={Colors.black} />
          <Text style={styles.itemText}>
            {mercato.when}
          </Text>
        </View>
      }
    </View>
  );
};

function Contatto({ contatto, index }) {
  var Icon = null;

  if (contatto.iconName === "email")
    Icon = MdEmail;
  else if (contatto.iconName === "phone")
    Icon = MdPhone;
  else if (contatto.iconName === "web")
    Icon = FaExternalLinkAlt;
  else if (contatto.iconName === "whatsapp")
    Icon = FaWhatsapp;
  else if (contatto.iconName === "instagram")
    Icon = FaInstagram;

  function clickContatto() {
    return () => {
      if (contatto.action === "copy") {
        Clipboard.setString(contatto.value);

        Toast.show({
          type: 'success',
          text1: 'Testo copiato negli appunti.',
          visibilityTime: 1300,
        });

      } else if (contatto.action === "redirect") {
        Linking.openURL(contatto.value).catch((error) =>
          Toast.show({
            type: 'error',
            text1: 'Reindirizzamento al sito non disponibile.',
            visibilityTime: 1500,
          })
        );
      }
    };
  }

  return (
    <>
      {index !== 0 && <View style={{ paddingTop: 6 }} />}
      <TouchableOpacity onPress={clickContatto()}>
        <View style={styles.sectionText}>
          {Icon &&
            <Icon size={18} color={Colors.black} />
          }
          <Text style={styles.itemText}>{contatto.name}</Text>
        </View>
      </TouchableOpacity>
    </>
  );
};

export default function Info({ params }) {
  const contatti = window.appData.contatti;
  const mercatiAbituali = window.appData.mercatiAbituali;
  const avvisi = window.appData.avvisi;

  return (
    <ScrollView keyboardDismissMode="on-drag" contentContainerStyle={styles.scrollViewContent}>

      <View style={styles.card}>
        <Text style={styles.sectionTitle}>
          i nostri contatti
        </Text>
        {contatti.map((contatto, index) => (
          <Contatto key={index} contatto={contatto} index={index} />
        ))}
      </View>

      <View style={styles.card}>
        <Text style={styles.sectionTitle}>
          i nostri mercati
        </Text>
        {mercatiAbituali.map((mercato, index) => (
          <Mercato key={index} mercato={mercato} index={index} />
        ))}

      </View>

      {avvisi.length !== 0 && (
        <View style={styles.card}>
          <Text style={styles.sectionTitle}>
            avvisi
          </Text>
          {avvisi.map((avviso, index) => (
            <View key={index} style={styles.sectionText}>
              <Text>{'\u2022'}</Text>
              <Text style={styles.itemText}>
                {avviso}
              </Text>
            </View>
          ))}
        </View>
      )}
      <Toast />
    </ScrollView>
  );
};


const styles = StyleSheet.create({
  scrollViewContent: {
    flexGrow: 1,
  },
  card: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 15,
    overflow: 'hidden',
    marginBottom: 10,
    backgroundColor: '#fff',
    paddingBottom: 10,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: "center",
    paddingTop: 7,
    paddingBottom: 6,
    paddingHorizontal: 7,
  },
  sectionText: {
    flexDirection: 'row',
    paddingHorizontal: 13,
    paddingBottom: 2,
  },
  itemText: {
    marginLeft: 7,
  },
  itemlabel: {
    width: 70,
  },
  urlText: {
    fontWeight: 'normal',
    fontStyle: 'italic',
    color: '#0000EE',
    textDecorationLine: 'underline',
  },
});
